/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { DateTimeCellModel } from "./DateTimeCellModel";
import { CanvasContentCellModelHelper } from "./CanvasContentCellModelHelper";
import { typeCast, Date_$type, markType } from "igniteui-react-core";
import { stringEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasDateTimeCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasDateTimeCellPresenter, _super);
    function CanvasDateTimeCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasDateTimeCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasDateTimeCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.as) {
            if (a.ax(DateTimeCellModel.k8) || a.ax(DateTimeCellModel.k9) || a.ax(DateTimeCellModel.k7)) {
                this.e(b);
                this.d.ck(b.ir);
            }
            CanvasContentCellModelHelper.a(this.a.bl, b, this.a);
        }
    };
    CanvasDateTimeCellPresenter.prototype.e = function (a) {
        a.ir = a.lk(a.k6);
        if (a.ir == stringEmpty()) {
            if (!(typeCast(Date_$type, a.gp) !== null)) {
                a.ir = a.gp.toString();
            }
        }
    };
    CanvasDateTimeCellPresenter.$t = markType(CanvasDateTimeCellPresenter, 'CanvasDateTimeCellPresenter', CanvasCellPresenterBase.$);
    return CanvasDateTimeCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasDateTimeCellPresenter };
//# sourceMappingURL=CanvasDateTimeCellPresenter.js.map
